export default {
  // 补0方法
  formatZero(num, len) {
    if (String(num).length > len) return num;
    return (Array(len).join(0) + num).slice(-len);
  },
  // localStorage存储
  setStore(name, content) {
    let contentClone = content;
    if (!name) return;
    if (typeof content !== "string") {
      contentClone = JSON.stringify(contentClone);
    }
    window.localStorage.setItem(name, contentClone);
  },
  // localStorage获取
  getStore(name) {
    if (!name) return null;
    return window.localStorage.getItem(name);
  },
  // localStorage删除
  removeStore(name) {
    if (!name) return;
    window.localStorage.removeItem(name);
  },
  // 日期格式化
  dateFormat(str, type) {
    let date = new Date(str);
    let year = date.getFullYear();
    let month = this.formatZero(date.getMonth() + 1, 2);
    let day = this.formatZero(date.getDate(), 2);
    let hour = this.formatZero(date.getHours(), 2);
    let minute = this.formatZero(date.getMinutes(), 2);
    let seconds = this.formatZero(date.getSeconds(), 2);
    let milliseconds = this.formatZero(date.getMilliseconds(), 3);
    if (type == "YYYY-MM-DD") {
      return `${year}-${month}-${day}`;
    } else if (type == "YYYY-MM-DD HH:MM:SS") {
      return `${year}-${month}-${day} ${hour}:${minute}:${seconds}`;
    } else if (type == "MM/DD HH:MM:SS") {
      return `${month}/${day} ${hour}:${minute}:${seconds}`;
    } else if (type == "YYYY,MM,DD") {
      return `${year},${month},${day}`;
    } else if (type == "YYYY-MM-DD HH:MM:SS:ll") {
      return `${year}-${month}-${day} ${hour}:${minute}:${seconds} ${milliseconds}`;
    } else if (type == "YYYY.MM.DD") {
      return `${year}.${month}.${day}`;
    }
  },
  // 获取时间完整
  getAllTime(value) {
    if (value) {
      return value.substring(0, 19).replace("T", " ");
    }
  },
  // 获取当前时间前后N天前后日期
  getDateBefore(dayCount) {
    var date = new Date();
    date.setDate(date.getDate() + dayCount);
    let year = date.getFullYear();
    let month = this.formatZero(date.getMonth() + 1, 2);
    let day = this.formatZero(date.getDate(), 2);
    return `${year}-${month}-${day}`;
  },
  getDistanceSpecifiedTime(dateTime) {
    // 指定日期和时间
    var EndTime = new Date(dateTime);
    // 当前系统时间
    var NowTime = new Date();
    var t = EndTime.getTime() - NowTime.getTime();
    var d = Math.floor(t / 1000 / 60 / 60 / 24);
    return d;
  },
  /*
   * 封装公共金额转化大小写文件
   * @author   王天瑜
   * @date     2019-06-14
   *
   */
  money(n) {
    if (n == 0) {
      return;
    }
    if (!/^(0|[1-9]\d*)(\.\d+)?$/.test(n)) {
      return "";
    }

    var unit = "仟佰拾亿仟佰拾万仟佰拾圆角分",
      str = "";
    n += "00";
    var p = n.indexOf(".");
    if (p >= 0) n = n.substring(0, p) + n.substr(p + 1, 2);

    unit = unit.substr(unit.length - n.length);

    for (var i = 0; i < n.length; i++)
      str += "零壹贰叁肆伍陆柒捌玖".charAt(n.charAt(i)) + unit.charAt(i);
    return str
      .replace(/零(仟|佰|拾|角)/g, "零")
      .replace(/(零)+/g, "零")
      .replace(/零(万|亿|圆)/g, "$1")
      .replace(/(亿)万|壹(拾)/g, "$1$2")
      .replace(/^圆零?|零分/g, "")
      .replace(/圆$/g, "圆整");
  },
  tableFill(list) {
    list.map((item, index) => {
      for (var i in item) {
        if (item[i] === "" || item[i] == null || item[i] == "null") {
          item[i] = "--";
        }
      }
    });
    return list;
  },
};
